import { render, staticRenderFns } from "./fieldData.vue?vue&type=template&id=8bcbce8c"
import script from "./fieldData.vue?vue&type=script&lang=js"
export * from "./fieldData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bcbce8c')) {
      api.createRecord('8bcbce8c', component.options)
    } else {
      api.reload('8bcbce8c', component.options)
    }
    module.hot.accept("./fieldData.vue?vue&type=template&id=8bcbce8c", function () {
      api.rerender('8bcbce8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/fieldData.vue"
export default component.exports